// extracted by mini-css-extract-plugin
export var formContainer = "_iq-0";
export var message = "_iq-1";